import * as React from 'react';

function SvgDownload(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg width={13} height={13} fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
      <path
        d='M5.778 8.257a.857.857 0 00.57.243.77.77 0 00.569-.243l2.92-2.9a.761.761 0 00-.015-1.114.82.82 0 00-1.138.014L7.15 5.786v-5a.802.802 0 00-.804-.785.802.802 0 00-.803.785v5L4.011 4.257a.82.82 0 00-1.14-.014c-.32.3-.32.8-.014 1.114l2.92 2.9z'
        fill='#51D9B0'
      />
      <path
        d='M11.902 6.83a.802.802 0 00-.803.786v2.814H1.606V7.616a.802.802 0 00-.803-.786.802.802 0 00-.803.786v3.6c0 .428.365.785.803.785h11.099a.802.802 0 00.803-.785v-3.6a.792.792 0 00-.803-.786z'
        fill='#51D9B0'
      />
    </svg>
  );
}

export default SvgDownload;
